// 函数节流
export const Throttle = () => {
  let flags = true // 是否首次调用
  let timeout = null
  return function(func, time) {
    let _fn = func // 保存需要被延迟的函数引用
    if (flags) {
      _fn()
      flags = false
      clearTimeout(timeout)
      timeout = setTimeout(function() {
        // 延迟执行
        flags = true
      }, time)
    }
  }
}

// 验证表单与规定填写的数据是否一致
export const validateCheckForm = (rule, value, callback, check_form) => {
  let key = rule.field
  // replace(/\s+/g, "")
  const pass_validate = localStorage.getItem('pass_validate')
  if (pass_validate == '1') {
    callback()
  } else if (!value) {
    callback(new Error('请填写'))
  } else if (!check_form[key]) {
    callback()
  } else if (String(value) != String(check_form[key])) {
    callback(new Error('请查看工具箱文档内信息或任务提示'))
  } else {
    callback()
  }
}

export const domainURI = str => {
  // eslint-disable-next-line no-useless-escape
  const durl = /http:\/\/([^\/]+)\//i
  const domain = str.match(durl)
  const http_ = str.indexOf('https://') === 0 ? 'https://' : 'http://'
  return http_ + domain[1]
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

//生成从minNum到maxNum的随机数
export function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return Math.floor(Math.random() * minNum + 1)
    case 2:
      return Math.floor(Math.random() * (maxNum - minNum + 1) + minNum)
    default:
      return 0
  }
}
// 下载文件
export const downloadFile = async (url, filename) => {
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('download', filename || '') // 自定义文件名（有效）
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
// 下载跨域地址的文件
export const downloadFileCors = async (url, filename) => {
  var xhr = new XMLHttpRequest()
  xhr.open('GET', url, true) // 异步
  xhr.responseType = 'blob' // blob 类型
  xhr.onload = function() {
    if (xhr.status != 200) {
      alert('下载异常！')
      return
    }
    const navigator = window.navigator
    if (navigator.msSaveOrOpenBlob) {
      // IE
      navigator.msSaveBlob(xhr.response, filename)
    } else {
      var newUrl = window.URL.createObjectURL(xhr.response)
      var a = document.createElement('a')
      a.setAttribute('href', newUrl)
      a.setAttribute('target', '_blank')
      a.setAttribute('download', filename) // 自定义文件名（有效）
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
  xhr.send()
}

// 字母和数字
export const numberAdd = (rule, value) => {
  const reg = /^[0-9a-zA-Z]*$/g
  if (reg.test(value)) {
    return Promise.resolve()
  } else {
    return Promise.reject('请输入数字或者字母')
  }
}

export class RandomUtil {
  static randomString(ranStr = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz', length) {
    var chars = ranStr.split('')
    var str = ''
    for (var i = 0; i < length; i++) {
      str += chars[Math.floor(Math.random() * chars.length)]
    }
    return str
  }

  static getPrivateKey() {
    var str = RandomUtil.randomString(`0123456789abcdef`, 64)
    return str
  }
  static getPublicKey() {
    var head = Math.random() > 0.5 ? `02` : `03`
    var str = head + RandomUtil.randomString(`0123456789abcdef`, 64)
    return str
  }
  //0000000000000000000000000000000000
  static getAddressKey() {
    var head = `1`
    var str = head + RandomUtil.randomString(`123456789ABCDEFGHJKLMNPQRSTUVWXTZabcdefghikmnopqrstuvwxyz`, 33)
    return str
  }
  //0000000000000000000000000000000000000000000000000000000000000000
  static getLastHash() {
    var str = ``
    var ran = 2 //2个0
    for (var i = 0; i < ran; i++) {
      str += `0`
    }
    while (str.length < 64) {
      str += RandomUtil.randomString(`123456789abcdef`, 1)
    }
    return str
  }
  static getMokeergen() {
    var str = RandomUtil.randomString(`0123456789abcdef`, 64)
    return str
  }
  static getHash(zeroNum) {
    var str = ``
    var ran = zeroNum //zeroNum个0
    for (var i = 0; i < ran; i++) {
      str += `0`
    }
    while (str.length < 64) {
      str += RandomUtil.randomString(`123456789abcdef`, 1)
    }
    return str
  }
  static getCurrentHash() {
    var str = ``
    var ran = 2 //2个0
    for (var i = 0; i < ran; i++) {
      str += `0`
    }
    while (str.length < 64) {
      str += RandomUtil.randomString(`123456789abcdef`, 1)
    }
    return str
  }
  static getTradeHash() {
    var str = ``
    // var ran = 8;//8个0
    // for (var i = 0; i < ran; i++) {
    //  str += `0`;
    // }
    while (str.length < 64) {
      str += RandomUtil.randomString(`0123456789abcdef`, 1)
    }
    return str
  }
  static getSignData() {
    var num = 0
    var ran = Math.random()
    if (ran < 0.3) {
      num = 142
    } else if (ran < 0.6) {
      num = 144
    } else {
      num = 146
    }
    var str = RandomUtil.randomString(`0123456789abcdef`, num)
    return str
  }
  static getRanByList(list) {
    return list[Math.floor(Math.random() * list.length)]
  }
}
// 数字每三位增加一个逗号
export function toThousands(num) {
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

// 正整数
export const IsNumber = (rule, value, callback) => {
  console.log(rule, callback)
  const reg = /^[1-9][0-9]{0,}$/
  if (reg.test(value)) {
    return Promise.resolve()
  } else {
    return Promise.reject('请输入正确值')
  }
}
// 正整数包含0
export const IsNumbers = (rule, value, callback) => {
  console.log(rule, callback)
  const reg = /^([1-9]\d*|[0]{1,1})$/
  if (reg.test(value)) {
    return Promise.resolve()
  } else {
    return Promise.reject('请输入正确值')
  }
}
